'use strict';

var analyticsHelper = require('app_honda_cars/utils/analyticsHelper');
var hashUserData = analyticsHelper.hashUserData;
var configuratorHelpers = require('./configuratorHelpers');
var getConfiguratorLocation = configuratorHelpers.getConfiguratorLocation;
var buildConfiguratorSelectedModel = configuratorHelpers.buildConfiguratorSelectedModel;

/**
 * Fires when the save-build form is successfully submitted.
 * PII + opt-in flags are stashed by configurator.js into window.saveBuildCompleteExtra
 * BEFORE $form[0].reset() clears all field values.
 *
 * @param {Object} data - event data (unused, PII read from window.saveBuildCompleteExtra)
 */
function configureSaveBuildFormComplete(data) {
    var loc = getConfiguratorLocation();
    var summaryDataJSON = $('.js-save-summary').attr('data-car-summary-data');
    if (!summaryDataJSON) return;
    var summaryData = JSON.parse(summaryDataJSON);
    var productData = summaryData.data.product;
    var selectedModel = buildConfiguratorSelectedModel(productData, window.globalAccessoryData || []);
    var extra = window.saveBuildCompleteExtra || {};

    var rawSBUserData = {
        email: extra.email || null,
        phone: extra.phone || null,
        firstName: extra.firstName || null,
        lastName: extra.lastName || null
    };

    hashUserData(rawSBUserData).then(function (hashedSBData) {
        dataLayer.push({
            'event': 'custom.form',
            'group': 'Save build',
            'category': 'configurator',
            'action': 'Complete',
            'userRequestId': window.globalSaveuniqueCode || null,
            'timeSpent': analyticsHelper.getTimeSpent(),
            'userData': hashedSBData,
            'data': {
                'configurator ID': window.globalSaveuniqueCode || '',
                'location': loc.formattedAddress,
                'postcode': loc.postalCode,
                'dealer': loc.dealerName,
                'optIn': extra.optIn != null ? extra.optIn : null,
                'sharedetailsopIn': extra.sharedetailsopIn != null ? extra.sharedetailsopIn : null
            },
            models: [selectedModel]
        });
        window.saveBuildCompleteExtra = null;
    });
}

module.exports = configureSaveBuildFormComplete;
